/**
 * Bounded undo policy (spec §9.4): a 'taken' registration may be undone
 * only inside the 30-minute product window, and never once a proof video
 * is attached. The repository enforces the same window server-side; these
 * helpers only drive the visible UI state. Pure functions — unit tested.
 */
import { UNDO_WINDOW_MS } from '@/services/repositories'
import type { MedicationIntakeEvent } from '@/types'

export function isUndoAllowed(intakeEvent: MedicationIntakeEvent, nowMs = Date.now()): boolean {
  if (!intakeEvent.takenAt) return false
  if (intakeEvent.proofObjectPath) return false
  const takenMs = new Date(intakeEvent.takenAt).getTime()
  if (Number.isNaN(takenMs)) return false
  return nowMs - takenMs <= UNDO_WINDOW_MS
}

/** Remaining undo time in whole minutes, for visible Dutch copy. */
export function undoMinutesRemaining(intakeEvent: MedicationIntakeEvent, nowMs = Date.now()): number {
  if (!intakeEvent.takenAt) return 0
  const takenMs = new Date(intakeEvent.takenAt).getTime()
  if (Number.isNaN(takenMs)) return 0
  return Math.max(0, Math.ceil((UNDO_WINDOW_MS - (nowMs - takenMs)) / 60_000))
}
